module.exports = __webpack_public_path__ + "img/monkey.6142463b.svg";